"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var DisplayErrorMessage = function (_a) {
    var fieldName = _a.fieldName;
    return (react_1.default.createElement(formik_1.ErrorMessage, { name: fieldName, render: function (errorMessage) { return react_1.default.createElement("p", { className: "text-warning" }, errorMessage); } }));
};
exports.default = DisplayErrorMessage;
